const keys = [
    'Notify me when the product becomes available',
    'ThankYou',
    'NotifyMesubscriptionSuccess',
    'E-mail',
    'SMS',
    'Enter your email below to be notified when this item is back on stock.',
    'Enter telephone number',
    'E-mail address is not valid.',
];
export const translationKeys = () => keys.map((key) => key);
